<template>
  <div class="text-left" v-if="event && !executing">
    <div v-for="page in event.pages">
      <mdb-input :id="'page-' + page.id" :label="page.title"
                 type="checkbox" v-model="page.selected"/>

    </div>

    <mdb-btn @click="doSave" color="success" icon="save">Save</mdb-btn>
    <mdb-btn @click="doCancel" color="danger" icon="times-circle">Cancel</mdb-btn>

    <div v-if="showSeriesModal">
      <series-modal @closeModal="showSeriesModal=false" @seriesChoice="setSeriesChoice"/>
    </div>

  </div>

</template>

<script>
  import api from '../../services/groupsPlaceApi.js'
  import {mdbBtn, mdbIcon, mdbInput, mdbSwitch} from 'mdbvue';
  import SeriesModal from "./SeriesModal";

  export default {
    name: 'Event-Pages-Editor',
    components: {
      mdbBtn,
      mdbIcon,
      mdbInput,
      mdbSwitch,
      SeriesModal
    },
    props: {
      id: {
        type: Number,
        default: null
      }
    },
    computed: {
      userDetails() {
        return this.$store.state.userDetails
      },
      group() {
        return this.$store.state.currentGroup
      },
      executing() {
        return this.$store.state.executing
      }
    },
    data() {
      return {
        event: null,
        showSeriesModal: false,
        seriesChoice: null
      }
    },
    mounted() {
      this.$store.dispatch("setExecuting", true);
      api.get("/event/pages/" + this.id).then(
        (results) => {
          this.event = results.data;
        },
        (error) => {
          this.$notify.error({message: "Could not load pages. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    methods: {
      doCancel() {
        this.$emit("cancel")
      },
      setSeriesChoice(choice) {
        this.event.series = choice
        this.doSave()
      },
      doSave() {
        if (this.event.repeats && !this.event.series) {
          this.showSeriesModal = true
          return
        }
        this.$store.dispatch("setExecuting", true);
        api.post('/event/pages/' + this.id, this.event).then(
          (results) => {
            this.$emit("save", this.event)
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 10000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
          this.showSeriesModal = false
          this.seriesChoice = null
        })
      }
    }
  }
  ;
</script>
